import React from 'react';
import './SkeletonLoader.css';

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-text short"></div>
    </div>
  );
}

export function SkeletonProgressBar() {
  return (
    <div className="skeleton-progress-container">
      <div className="skeleton-line skeleton-label"></div>
      <div className="skeleton-progress-bar">
        <div className="skeleton-progress-fill"></div>
      </div>
    </div>
  );
}

export function SkeletonTable() {
  return (
    <div className="skeleton-table">
      <div className="skeleton-table-header">
        <div className="skeleton-line skeleton-th"></div>
        <div className="skeleton-line skeleton-th"></div>
        <div className="skeleton-line skeleton-th"></div>
        <div className="skeleton-line skeleton-th"></div>
      </div>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="skeleton-table-row">
          <div className="skeleton-line skeleton-td"></div>
          <div className="skeleton-line skeleton-td small"></div>
          <div className="skeleton-line skeleton-td small"></div>
          <div className="skeleton-line skeleton-td small"></div>
        </div>
      ))}
    </div>
  );
}

function SkeletonLoader() {
  return null;
}

export default SkeletonLoader;

